<template>
  <div>
    <form :action="action_url" method="POST" class="validate-form inventory_form">
      <input type="hidden" name="_token" :value="csrf">
      <br>
      <table class="b-warehouse__bonuses-table">
        <thead>
        <tr>
          <th class="col-md-4" v-text="trans('title')"></th>
          <th class="col-md-2" v-text="trans('available_quantity')"></th>
          <th class="col-md-2" v-text="trans('reserve')"></th>
          <th class="col-md-2" v-text="trans('total_quantity')"></th>
          <th class="col-md-2">
            <span v-if = "section === 'inventory'" v-text="trans('new_quantity')"></span>
            <span v-else v-text="trans('add_to_stock')"></span>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="packages in packages">
          <td class="col-md-4">
            <span v-text="packages.title"></span>
          </td>
          <td class="col-md-1">
            <input
                :name="'data[' + packages.id + '][reserve]'"
                type="hidden"
                :value="packages.available_quantity"/>
            <span v-text="packages.available_quantity"></span>
          </td>
          <td class="col-md-1">
            <input
                :name="'data[' + packages.id + '][reserve]'"
                type="hidden"
                :value="packages.calculatedReserve"/>
            <span v-text="packages.calculatedReserve"></span>
          </td>
          <td class="col-md-1">
            <div v-if = "section === 'inventory'" >
              <input type="hidden"
                     :name="'data[' + packages.id + '][old_total_quantity]'"
                     :value="packages.available_quantity + packages.calculatedReserve"/>
              <span v-text="packages.available_quantity + packages.calculatedReserve"></span>
            </div>
            <div v-else>
              <span v-text="packages.available_quantity + packages.calculatedReserve"></span>
            </div>
          </td>
          <td class="col-md-2">
            <input v-if = "section === 'inventory'"
                   :name="'data[' + packages.id + '][new_total_quantity]'"
                   class="form-control input-sm b-warehouse__new-count"
                   type="number"
                   min="0"
                   step="1"
                   :value="packages.available_quantity + packages.calculatedReserve">
            <input v-else
                   :name="'data[' + packages.id + '][quantity]'"
                   class="form-control input-sm b-warehouse__new-count"
                   type="number"
                   min="0"
                   step="1"
                   value="0">
          </td>
        </tr>
        </tbody>
      </table>
      <div class="pull-right">
        <br>
        <input type="submit"
               class="btn btn-primary inventory_submit"
               :value="trans('save_button', null)"
        >
      </div>
    </form>
  </div>
</template>

<script>
let Functions = require("../../Functions");

module.exports = {
  props: ['section', 'packages', 'translations'],
  data: function () {
    return {
      csrf: '',
      selected_domains: [],
      action_url: "/warehouse/" + this.section + "/packages",
    };
  },
  mounted: function () {
    let token = document.querySelector('#token').getAttribute('content');
    Vue.http.headers.common['X-CSRF-TOKEN'] = token;
    this.csrf = token;
  },
  methods: {
    trans(name, path = 'stock') {
      return Functions.trans(this.translations, name, path);
    },
  }
};
</script>